import type { StaffCatalogItemType } from "@lafayette/schemas";
import type { ComponentType } from "react";

import { DiningSection, diningFieldLabels } from "./DiningSection";
import { EventSection, eventFieldLabels } from "./EventSection";
import { ExperienceSection, experienceFieldLabels } from "./ExperienceSection";
import { ServiceSection, serviceFieldLabels } from "./ServiceSection";
import type { SubtypeSectionProps } from "./support";
import { VillaSection, villaFieldLabels } from "./VillaSection";

// The type-aware part of the forms. The create page and the edit section look the component up by the
// item's type: there is no `switch` on the type in a form, and a new item type adds one entry here.

export const subtypeSections: Readonly<
  Record<StaffCatalogItemType, ComponentType<SubtypeSectionProps>>
> = {
  DINING: DiningSection,
  VILLA: VillaSection,
  EVENT: EventSection,
  EXPERIENCE: ExperienceSection,
  SERVICE: ServiceSection,
};

/** Field labels per type, in page order, for the error summary. */
export const subtypeFieldLabels: Readonly<
  Record<StaffCatalogItemType, Readonly<Record<string, string>>>
> = {
  DINING: diningFieldLabels,
  VILLA: villaFieldLabels,
  EVENT: eventFieldLabels,
  EXPERIENCE: experienceFieldLabels,
  SERVICE: serviceFieldLabels,
};
